//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useEffect, useState } from "react"

// === API ===
import {on, removeListener, sendMessage} from "api/prokey/prokey.websocket";

//#endregion

const ExpressionContext = createContext()

//-----------------------------------------------------------------
function ExpressionProvider( { children } ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const [ next_id     , setNextId      ] = useState( 0  );
  const [ expressions , setExpressions ] = useState( [] );
  const [ fields      , setFields      ] = useState( [] );
  const [ records     , setRecords     ] = useState( [] );
  const [ tables      , setTables      ] = useState( [] );
  const [ documents   , setDocuments   ] = useState( [] );
  const [ table_columns, setTableColumns ] = useState( {} );

  const [ is_saved , setIsSaved ] = useState( true );

  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    //-----------------------------------------------------------------    
    function listener(data) {
      //-----------------------------------------------------------------
      create( data.rule.rule.RULE.values );
    }
    //-----------------------------------------------------------------    
    function listener2(data) {
      //-----------------------------------------------------------------
      const temp = data.fields.map( x=> {return {label: x, value: x} });
      setFields( temp );
    }
    //-----------------------------------------------------------------    
    function listener4(data) {
      //-----------------------------------------------------------------
      const temp = data.tables.map( x=> {return {label: x, value: x} });
      setTables( temp );
    }
    //-----------------------------------------------------------------    
    function listener3(data) {
      //-----------------------------------------------------------------
      const temp = data.documents;
      setDocuments( temp );
    }
    //-----------------------------------------------------------------    
    function listener5(data) {
      //-----------------------------------------------------------------
      const temp = data.records.map( x=> {return {label: x, value: x} });
      setRecords( temp );
    }
    //-----------------------------------------------------------------    
    function listener6(data) {
      //-----------------------------------------------------------------
      const temp = { ...table_columns };
      temp[data.table] = data.columns.map( x => { return {label: x, value: x} } );
      setTableColumns( temp );
    }

    on( 'ANALYTICS_RULE' , listener  );
    on( 'FIELD-LIST'     , listener2 );
    on( 'DOCUMENT-LIST'  , listener3 );
    on( 'TABLE-LIST'     , listener4 );
    on( 'RECORD-LIST'    , listener5 );
    on( 'TABLE-COLUMNS'  , listener6 );
    
    const message  = JSON.stringify( { type: 'FIELD-LIST-REQUEST', data: { } } );
    sendMessage( message );
    
    const message4 = JSON.stringify( { type: 'TABLE-LIST-REQUEST', data: { } } );
    sendMessage( message4 );
    
    const message2 = JSON.stringify( { type: 'DOCUMENT-LIST-REQUEST', data: { tenant: '' } } );
    sendMessage( message2 );
    
    const message5 = JSON.stringify( { type: 'RECORD-LIST-REQUEST', data: { } } );
    sendMessage( message5 );

    return () => {
      removeListener( 'ANALYTICS_RULE' , listener  );
      removeListener( 'FIELD-LIST'     , listener2 );
      removeListener( 'TABLE-LIST'     , listener4 );
      removeListener( 'DOCUMENT-LIST'  , listener3 );
      removeListener( 'RECORD-LIST'    , listener5 );
    };
  }, [] ); // empty dependency = called only once at startup

  useEffect(() => {
    const listener = (event) => {
      if( is_saved ) return;
      event.preventDefault();
      event.returnValue = 'test';
    }

    window.addEventListener('beforeunload', listener );

    return () => {
      window.removeEventListener('beforeunload', listener );
    };
  }, [is_saved]);

  //#endregion

  //-----------------------------------------------------------------
  function create( values ) {
    //-----------------------------------------------------------------
    let count = next_id;
    const array = values.map( data => { return { id: count++, data }; });
    setExpressions( array );

    setNextId( count+1 );
  }

  //-----------------------------------------------------------------
  function createExpression( data = {} ) {
    //-----------------------------------------------------------------
    const new_exp = { id: next_id, data };
    
    setExpressions( [
      ...expressions,
      new_exp,
    ])

    setNextId( next_id + 1 );
    setIsSaved( false );
  }

  //-----------------------------------------------------------------
  function updateExpression( id, data ) {
    //-----------------------------------------------------------------
    const temp = expressions.map( exp => {
      const is_exp = exp.id === id;
      if( is_exp ) {
        const new_data = { ...exp.data, ...data };
        const new_exp = { id: exp.id, data: new_data };
        return new_exp;
      }

      return exp;
    } );
    
    setExpressions( temp );
    setIsSaved( false );
  }

  //-----------------------------------------------------------------
  function removeExpression( id ) {
    //-----------------------------------------------------------------
    const temp = expressions.filter( exp => exp.id !== id );
    setExpressions( temp );
    setIsSaved( false );
  }

  //-----------------------------------------------------------------
  function updateTableMatch( id, data ) {
    //-----------------------------------------------------------------
    const temp = expressions.map( exp => {
      const is_exp = exp.id === id;
      if( !is_exp ) return exp

      const new_data = { ...exp.data, ...data };
      const new_exp = { id: exp.id, data: new_data };
      return new_exp;
    } );
    
    setExpressions( temp );
    setIsSaved( false );
  }

  //-----------------------------------------------------------------
  function save( ) {
    //-----------------------------------------------------------------
    setIsSaved( true );
  }

  const values = { 
    expressions , setExpressions ,
    removeExpression, createExpression, updateExpression, save,
    fields, documents, tables, records, table_columns,
  };

  return (
    <ExpressionContext.Provider value={ values }>
      {children}
    </ExpressionContext.Provider>
  );
};

export { ExpressionContext, ExpressionProvider };